import NetworkLogic from "../../Shared/NetworkLogic";
import Player from "../../Models/Player";
import UIManager from "../../Shared/UIManager";
import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;
const i18n = require('LanguageData');

@ccclass
export default class ReceiveRecords extends cc.Component {
    @property(cc.Node)
    nodata : cc.Node = null;
    @property(cc.SpriteFrame)
    sp1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    sp2: cc.SpriteFrame = null;
    @property(cc.Node)
    content: cc.Node = null;


    // onLoad () {}
    /**
     * ,"data":[{"reward":801.60,"stlmDate":1581415732000}],"
     */
    onEnable(): void {
        let data = {
            "receiveType": 1,
            "userId": Player.getPy("userID")
        }
        UIManager.showLoadingUI();
        NetworkLogic.agentReturnReceiveInfo(data,1,9999,function (rdata) {
            UIManager.hideLoadingUI();
            this.data = rdata;
            let item = null;
            if (!rdata) return;
            this.nodata.active = false;
            if (this.content.children.length > rdata.length){
                for (let i = rdata.length; i < this.content.children.length;i++){
                    this.content.children[i].active = false;
                }
            }
            rdata = rdata.reverse()
            for (let i = 0; i < rdata.length;i++){
                if(this.content.children.length > i){
                    item = this.content.children[i];
                }
                else
                    item = cc.instantiate(this.content.children[0]);

                item.getChildByName("labName").getComponent(cc.Label).string = rdata[i].stlmDate;
                item.getChildByName("labMoney").getComponent(cc.Label).string = Player.getPy("currencySymbol") + rdata[i].reward;
                item.getChildByName("sprite").getComponent(cc.Sprite).spriteFrame = (i % 2 === 0 ? this.sp1 : this.sp2);
                item.parent = this.content;
                item.active = true;
            }

        }.bind(this),function () {
            console.log("==== 领奖记录错误");
        }.bind(this))
    }
    start () {

    }
    onBtnClick(event,param){
        AudioManager.playSound("close");
        this.node.active = false;
    }

}
